import React from 'react';
import { Logo, Flag, Pill, EntityLink, BackButton } from './ui';
import { latestResult, latestFixtures, resultFor, FORM_BADGE, activeTeamSeason } from '../../lib/clubHelpers';

export default function ClubHeader({ data, backPath, showBack = true }) {
  const ov = data?.overview || {};
  const season = activeTeamSeason(ov);
  const leagueId = season?.league?.id;
  const fixtures = latestFixtures(ov, data?.recentFixtures);
  const form = fixtures.slice(0, 5).map((f) => latestResult(f) || resultFor(f, ov?.name)).filter(Boolean);

  return (
    <div className="i-card p-5 mb-4">
      {showBack && <BackButton to={backPath || '/club-intelligence'} label="Back to Club Intelligence" />}
      <div className="flex flex-wrap items-center gap-4 mt-3">
        <Logo src={ov?.image_path} alt={ov?.name} size={84} fallback={ov?.name} />
        <div className="min-w-0 flex-1">
          <h1 className="i-fg text-2xl font-bold tracking-tight">{ov?.name || '—'}</h1>
          <div className="flex flex-wrap items-center gap-3 mt-2">
            {ov?.country?.image_path && <Flag src={ov.country.image_path} alt={ov.country.name} size={18} />}
            <span className="i-mute text-sm">{ov?.country?.name || '—'}</span>
            {ov?.type && <Pill>{ov.type}</Pill>}
            {ov?.short_code && <Pill className="i-bd">{ov.short_code}</Pill>}
            {ov?.venue?.name && <span className="i-dim text-sm">{ov.venue.name}</span>}
          </div>
        </div>
        {form.length > 0 && (
          <div className="flex gap-1.5">
            {form.map((r, i) => (
              <span key={i} className={'i-form-badge ' + (FORM_BADGE[r] || 'i-bd')}>{r}</span>
            ))}
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-4 mt-4 pt-4 border-t border-shell-border text-sm">
        <div><span className="i-mute">Founded </span><span className="i-fg font-semibold">{ov?.founded ?? '—'}</span></div>
        <div><span className="i-mute">Rating </span><span className="i-fg font-semibold">{ov?.rating ?? '—'}</span></div>
        {season?.name && (
          <div>
            <span className="i-mute">Active season </span>
            <EntityLink to={leagueId ? `/league/${leagueId}` : null} className="i-fg font-semibold">{season.name}</EntityLink>
            {season?.is_current && !season?.finished && <Pill className="i-pos-def ml-2">Live</Pill>}
          </div>
        )}
      </div>
    </div>
  );
}
